module.exports = __webpack_public_path__ + "img/img-2.f44d2fb4.jpg";